import { addSavedOffer } from '@cian/favorites-assign-widget';
import { IFavoriteChangeResponse } from 'shared/api/favorite';
import { Dispatch, IAppState } from 'shared/common/state';
import { showMotivationPopup } from 'shared/serp/state/login_motivation_popup';

import { newbuildingLayoutsFavorite } from './actions';

const FAVORITES_LIMIT_FOR_UNAUTH_USER = 5;

export function changeLayoutFavorite(offerId: number, isFavorite: boolean) {
  return (dispatch: Dispatch, getState: () => IAppState) => {
    const { user, loginMotivationPopupOnFavorite, makeRequest } = getState();
    // oxlint-disable-next-line typescript/no-explicit-any
    const currentCount = (window as any).__header_favorites_count__ || 0;

    if (isFavorite && !user.isAuthenticated && currentCount >= FAVORITES_LIMIT_FOR_UNAUTH_USER) {
      // oxlint-disable-next-line typescript/no-explicit-any
      if ((window as any).__headerLoginPopupShowMotivation) {
        // oxlint-disable-next-line typescript/no-explicit-any
        (window as any).__headerLoginPopupShowMotivation();
      }
    } else {
      dispatch(newbuildingLayoutsFavorite({ offerId, isFavorite }));

      if (isFavorite) {
        // oxlint-disable-next-line typescript/no-explicit-any
        (window as any).__header_favorites_count__ = currentCount + 1;

        if (!user.isAuthenticated && loginMotivationPopupOnFavorite.isActive) {
          dispatch(showMotivationPopup(offerId));
        }
      } else {
        // oxlint-disable-next-line typescript/no-explicit-any
        (window as any).__header_favorites_count__ = currentCount - 1;
      }

      makeRequest({
        apiType: 'legacy',
        microserviceName: 'monolith-python',
        pathApi: '/ajax/sale/flat/favorites',
        parameters: {
          action: isFavorite ? 'assign' : 'remove',
          oid: offerId,
          addToFolder: isFavorite ? true : undefined,
        },
        headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
        bodyAsEncodeString: true,
        method: 'POST',
      }).then(
        (data: IFavoriteChangeResponse) => {
          if (isFavorite) {
            const userHasFolders = Boolean(data.folderInfo && data.folderInfo.hasFolders);
            const folder = data.folderInfo?.folder;

            let savedInFolders = null;
            if (folder?.name && folder?.id) {
              savedInFolders = [
                {
                  id: folder.id,
                  name: folder.name,
                },
              ];
            }

            dispatch(addSavedOffer({ offerIds: [offerId], savedInFolders, userHasFolders }));
          }

          if (data.newbuilding_id !== undefined && window.__header_updateFavorites__) {
            window.__header_updateFavorites__(true);
          }

          return window.__header_updateFavorites__ && window.__header_updateFavorites__(isFavorite);
        },
        () => {
          // oxlint-disable-next-line typescript/no-explicit-any
          (window as any).__header_favorites_count__ = currentCount - 1;
        },
      );
    }
  };
}
